import { render, staticRenderFns } from "./DetalheAgenda.vue?vue&type=template&id=a1cc96c2&scoped=true&"
import script from "./DetalheAgenda.vue?vue&type=script&lang=js&"
export * from "./DetalheAgenda.vue?vue&type=script&lang=js&"
import style0 from "./DetalheAgenda.vue?vue&type=style&index=0&id=a1cc96c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cc96c2",
  null
  
)

export default component.exports